import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../../images/location_new/fold5/img02.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#262032" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Team Up with TekRevol for App-Solute Business Success</h2>
            <p>
              Mobile applications are your direct connection to customers. At
              TekRevol, we understand the importance of crafting mobile apps
              that not only meet but exceed expectations. Whether it's enhancing
              user experiences, streamlining processes, or creating innovative
              solutions, our focus is on translating your vision into a seamless
              and impactful mobile app.
            </p>
            <p>
              Partner with us, and watch your ideas turn into success stories.
              Your vision, our expertise – a winning combination for your
              business journey!
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#262032",
                border: "1px solid #262032",
              }}
              to="https://www.tekrevol.com/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
